import React, { useState, useRef } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";

const ModalCreate = ({
  isOpen,
  toggle,
  title,
  token,
}) => {
  const [nombre, setNombre] = useState("");
  const [numeroContacto, setNumeroContacto] = useState("");
  const [, setFormMode] = useState("none");
  const modalRef = useRef(null);

  const handleNombreChange = (event) => {
    setNombre(event.target.value);
  };
  const handleNumeroContactoChange = (event) => {
    setNumeroContacto(event.target.value);
  };

  const handleCreateSubmit = (event) => {
    event.preventDefault();
    axios
      .post("/conductor", {
        Nombre: nombre,
        Celular: parseInt(numeroContacto),
      }, {headers: { Authorization: `Bearer ${token}` }})
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Creado!",
          text: "el conductor ha sido creado con exito",
          showCloseButton: true,
        }).then(() => {
          window.location.reload();
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Ha ocurrido un error al crear el conductor.",
          showCloseButton: true,
        });
      });
  };

  return (
    <Modal ref={modalRef} isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <label>Nombre conductor:</label>
          <input
            className="form-control"
            name="rol"
            type="text"
            value={nombre}
            onChange={handleNombreChange}
          />
        </FormGroup>
        <FormGroup>
          <label>Numero de contacto:</label>
          <input
            className="form-control"
            name="rol"
            type="text"
            value={numeroContacto}
            onChange={handleNumeroContactoChange}
          />
        </FormGroup>
        
      </ModalBody>

      <ModalFooter>
        <Button onClick={handleCreateSubmit} color="primary" otype="submit">
          Insertar
        </Button>
        <Button color="danger" onClick={() => setFormMode("none")}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalCreate;
